module.exports = __webpack_public_path__ + "img/icon_my_resources@2x.f36af8f4.png";